import { useState } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs

// Components
import MoreItem from '../../../../sharedComponents/MoreItem'
import Quality from '../../../../sharedComponents/Quality'
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface MoreProps {
  className?: string
  isHost: boolean
  morePopopRef: any
}

const MORE_PAGE = {
  LIST: 'list', // 列表
  QUALITY: 'quality',
  FEEDBACK: 'feedback',
}

const MORE_TITLE = {
  [MORE_PAGE.LIST]: 'LiveRoom_More',
  [MORE_PAGE.QUALITY]: 'LiveRoom_Quality',
  [MORE_PAGE.FEEDBACK]: 'LiveRoom_Feedback',
}

const More = (props: MoreProps) => {
  const { className, isHost, morePopopRef } = props

  const { t } = useTranslation()

  const [currentPage, setCurrentPage] = useState(MORE_PAGE.LIST)

  const isListPage = currentPage === MORE_PAGE.LIST

  return (
    <div className={cx('more', className)}>
      <div className={cx('more-title')}>
        {!isListPage && (
          <div className={cx('more-title-back')} onClick={() => setCurrentPage(MORE_PAGE.LIST)}>
            <Icon.ArrowLeft />
          </div>
        )}
        <p className={cx('more-title-text')}>{t(MORE_TITLE[currentPage])}</p>
      </div>

      {isListPage && (
        <div className={cx('more-list')}>
          {!isHost && (
            <MoreItem
              className={cx('more-list-item')}
              onClick={() => setCurrentPage(MORE_PAGE.QUALITY)}
              text={t('LiveRoom_Quality')}
              icon={Icon.Setting}
            />
          )}
          {/* TODO: 還沒實作 */}
          {/* {<MoreItem className={cx('more-list-item')} text={t('LiveRoom_Feedback')} icon={Icon.Setting} />} */}
        </div>
      )}

      {currentPage === MORE_PAGE.QUALITY && <Quality handleClose={() => morePopopRef.current.setIsPopupOpen(false)} />}
    </div>
  )
}

export default More
